import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, buttonField} from '../../core/redux/form'
import {autocompleteMatcher, displayPrediction, highlightPrediction, getPredictionAddress} from '../../core/google/places'
import Icon from '../../core/components/Icon'
import TypeaheadInput, {matcher, multiMatcher} from '../../core/components/TypeaheadInput'
import LoaderButton from '../../core/components/LoaderButton'
import {ADD_ADDRESS_TO_LOT_CMD_UPDATED, loadLot, sendAddAddressToLotCmd, sendRemoveAddressFromLotCmd, sendReferenceBuildingCmds, updateAddAddressToLotCmd} from '../actions'
import {AddAddressToLotCmd} from '../models'
import i18n from '../i18n'
import style from './AddRemoveAddressFromLotPopover.less'

function addressMultiMatcher(addresses) {
    const googleSource = autocompleteMatcher
    const addressSource = matcher({
        source: addresses,
        identify: (a) => a.number + ' ' + a.street + ' ' + a.city
    })

    return multiMatcher([addressSource, googleSource])
}

class AddRemoveAddressFromLotPopover extends Component {

    static propTypes = {
        addresses: PropTypes.array.isRequired,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {addresses} = this.props

        const addressSource = addressMultiMatcher(addresses)
        this.setState({addressSource})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.addresses != this.props.addresses) {
            const {addresses} = nextProps

            const addressSource = addressMultiMatcher(addresses)
            this.setState({addressSource})
        }
    }

    _sendAddCmd() {
        const {dispatch, cmd, onHide} = this.props
        const {typeahead} = this.refs
        
        return dispatch(sendReferenceBuildingCmds([cmd.address])).then((action) => {
            return dispatch(updateAddAddressToLotCmd({address: action.addresses[0]}))
        }).then(() => {
            return dispatch(sendAddAddressToLotCmd())    
        }).then(() => {
            return dispatch(loadLot())
        }).then(() => {
            typeahead.reset()
        })
    }

    _sendRemoveCmd(event, address) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendRemoveAddressFromLotCmd(address.uid)).then(() => {
            return dispatch(loadLot())
        })
    }

    render() {
        const {dispatch, form, cmd, addresses, lot, onHide, ...others} = this.props
        const {addressSource} = this.state
        const {buildingInput} = this.refs

        const displayAddressTypeahead = (addressOrPrediction) => {
            if (addressOrPrediction.city) {
                const address = addressOrPrediction
                var text = address.number + ' ' + address.street + ' ' + address.city
                text = text + (address.building && (' - ' + i18n.addressBuilding + ' ' + address.building.label) || '')
                return text
            }
            return displayPrediction(addressOrPrediction)
        }

        const highlightAddressTypeahead = (addressOrPrediction) => {
            if (addressOrPrediction.city) {
                return null
            }
            return highlightPrediction(addressOrPrediction)
        }

        const addressTypeaheadField = (field) => {
            
            function onChange(addressOrPrediction) {
                if (addressOrPrediction.city) {
                    const address = {...addressOrPrediction, uid: null}
                    field.onChange(address)
                    buildingInput.getInputDOMNode().focus()
                } else {
                    getPredictionAddress(addressOrPrediction, (predictionAddress) => {
                        const address = predictionAddress
                        field.onChange(address)
                        buildingInput.getInputDOMNode().focus()
                    })
                }
            }

            return {...field, onChange}
        }

        const addressTypeaheadButton = () => {
            if (cmd && cmd.address) {
                return (
                    <Button
                        {...buttonField(form.address(), null)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        return (
            <Popover
                title={i18n.addresses}
                {...others}>
                <ul className={style.addressGroup}>
                    {lot.addresses.map((address) => (
                        <li key={address.uid}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => this._sendRemoveCmd(e, address)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>
                                <span>{address.number}</span>
                                <span> {address.street}</span>
                                <span>, {address.zipCode}</span>
                                <span> {address.city}</span>
                            </p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Row>
                        <Col xs={4} sm={3}>
                            <Input
                                type='text'
                                name='gate'
                                placeholder={i18n.addressEntrance}
                                {...form.address.recipientSupplement.entrance()} />
                        </Col>
                        <Col xs={4} sm={9}>
                            <Input
                                type='text'
                                name='digicode'
                                placeholder={i18n.addressDigicode}
                                {...form.address.digicode()} />
                        </Col>
                        <Col xs={4} sm={3}>
                            <Input
                                type='text'
                                name='floor'
                                placeholder={i18n.addressFloor}
                                {...form.address.recipientSupplement.floor()} />
                        </Col>
                        <Col xs={4} sm={3}>
                            <Input
                                type='text'
                                name='unit'
                                placeholder={i18n.addressUnit}
                                {...form.address.recipientSupplement.unit()} />
                        </Col>
                        <Col xs={4} sm={3}>
                            <Input
                                type='text'
                                name='floor'
                                placeholder={i18n.addressElevator}
                                {...form.address.recipientSupplement.elevator()} />
                        </Col>
                        <Col xs={4} sm={3}>
                            <Input
                                type='text'
                                name='floor'
                                placeholder={i18n.addressStaircase}
                                {...form.address.recipientSupplement.staircase()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TypeaheadInput
                                ref='typeahead'
                                source={addressSource}
                                display={displayAddressTypeahead}
                                highlight={highlightAddressTypeahead}
                                placeholder={i18n.addAddress}
                                buttonAfter={addressTypeaheadButton()}
                                {...addressTypeaheadField(form.address())} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} sm={3}>
                            <Input disabled
                                type='text'
                                name='number'
                                placeholder={i18n.addressNumber}
                                {...form.address.number()} />
                        </Col>
                        <Col xs={8} sm={9}>
                            <Input
                                ref='buildingInput'
                                type='text'
                                name='building'
                                placeholder={i18n.addressBuilding}
                                disabled={form.address.building.uid().value != null}
                                {...form.address.building.label()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Input disabled
                                type='text'
                                name='street'
                                placeholder={i18n.addressStreet}
                                {...form.address.street()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} sm={3}>
                            <Input disabled
                                type='text'
                                name='zipCode'
                                placeholder={i18n.addressZipCode}
                                {...form.address.zipCode()} />
                        </Col>
                        <Col xs={8} sm={9}>
                            <Input disabled
                                type='text'
                                name='city'
                                placeholder={i18n.addressCity}
                                {...form.address.city()} />
                        </Col>
                    </Row>
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendAddCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AddRemoveAddressFromLotPopover = connectForm({
    target: 'cmd',
    schema: AddAddressToLotCmd.schema,
    action: ADD_ADDRESS_TO_LOT_CMD_UPDATED
})(AddRemoveAddressFromLotPopover)

AddRemoveAddressFromLotPopover = connect((state) => ({
    lot: state.patrimony.lot.lot,
    cmd: state.patrimony.addAddressToLotCmd
}))(AddRemoveAddressFromLotPopover)

export default AddRemoveAddressFromLotPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/AddRemoveAddressFromLotPopover.js